<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{ $t('edit.hpInfo.linkHP') }}</div>
    </div>

    <div class="tool-drawer-content">
      <IconSelect
        :currentIcon="linkObj.icon_url || ''"
        @onSelectIcon="onSelectIcon"
      ></IconSelect>
      <div class="tit-box">
        <div>
          <div style="margin-bottom: 5px">
            <span>{{ $t('edit.hpInfo.IconScale') }}</span>
          </div>
          <a-row class="titleScaleBg">
            <a-col :span="24">
              <a-slider :min="1" :max="300" :step="1" v-model="currScale" />
            </a-col>
          </a-row>
        </div>
        <div class="tit-desc">
          <span>{{ $t('edit.title') }}</span>
          <a-checkbox
            :checked="linkObj.is_show_title === 1"
            @change="isShowTitle"
          >
            {{ $t('edit.hpInfo.showTitle') }}
          </a-checkbox>
        </div>
        <div style="background-color: #212121">
          <div class="tit-desc-px">
            <a-input
              :placeholder="$t('edit.hpInfo.inputTitle')"
              v-model="currTitle"
            />
            <div class="tit-px">
              <a-input
                class="title-input"
                :placeholder="currFontSize"
                v-model="currFontSize"
              />
              <span style="padding-left: 2px">px</span>
            </div>
          </div>
          <div class="tit_position_bg">
            <a-button
              class="tit_position_btn"
              type="primary"
              v-for="(item, index) in btnPosition"
              :key="index"
              @click="onClickBtn(item, index)"
              :class="{ tit_active: index == currentPosition }"
            >
              {{ item.name }}
            </a-button>
          </div>
        </div>

        <div class="tit_sliderbar_bg">
          <a-row>
            <a-col :span="6" style="padding: 5px">
              {{ $t('edit.hpInfo.title_x') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_x" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" style="padding: 5px">
              {{ $t('edit.hpInfo.title_y') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_y" />
            </a-col>
          </a-row>
        </div>
        <!-- <a-row style="margin-top: 10px">
            <a-col :span="18">
              <a-slider :min="-300" :max="300" :step="1" v-model="linkObj.tit_position_x" />
            </a-col>
            <a-col :span="18">
              <a-slider :min="-300" :max="300" :step="1" v-model="linkObj.tit_position_y" />
            </a-col>
        </a-row>
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="linkObj.tit_position_align" />
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="linkObj.tit_position_edge" /> -->
      </div>

      <div style="margin: 20px">
        <div
          style="display: flex; justify-content: space-between; margin: 10px 0"
        >
          <a-tooltip placement="right" :title="$t('edit.hpInfo.tooltip')">
            {{ $t('edit.hpInfo.linkSites') }}
          </a-tooltip>
        </div>
        <a-input
          :placeholder="$t('edit.hpInfo.linkSites')"
          v-model="linkObj.content"
          @focus="handleInputFocus"
        />
        <!-- <div style="display: flex;justify-content: space-between;margin: 10px 0;">
          <a-tooltip
          placement="right"
          :title="$t('edit.hpInfo.tooltip')"
          >
          {{$t('edit.hpInfo.linkSitesYT')}}
          </a-tooltip>
        </div> -->
        <!-- <a-input :placeholder="$t('edit.hpInfo.linkSites')" v-model="linkObj.YTcontent" /> -->
        <a-radio-group
          class="target-type"
          name="radioGroup"
          :default-value="linkObj.targetType"
          @change="targetChange"
        >
          <a-radio :value="1">
            {{ $t('edit.hpInfo.newpagen') }}
          </a-radio>
          <a-radio :value="2">
            {{ $t('edit.hpInfo.currentpage') }}
          </a-radio>
          <a-radio :value="3">
            {{ $t('edit.hpInfo.popup') }}
          </a-radio>
        </a-radio-group>
      </div>
    </div>

    <div class="tool-drawer-btns">
      <DoubleBtn
        @onClickSave="onClickSave"
        @onClickCancel="clickDelete"
      ></DoubleBtn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IconSelect from './IconSelect.vue';
import { v4 as uuidv4 } from 'uuid';
import DoubleBtn from '../DoubbleBtn';
import { Modal } from 'ant-design-vue';

export default {
  components: { IconSelect, DoubleBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      btnPosition: [
        { name: '上', align: 'top', edge: 'bottom', x: 0, y: 0 },
        { name: '下', align: 'bottom', edge: 'top', x: 0, y: 0 },
        { name: '左', align: 'left', edge: 'right', x: 0, y: 0 },
        { name: '右', align: 'right', edge: 'left', x: 0, y: 0 },
      ],
      currentPosition: 0,
      linkObj: {
        type: 'link',
        hotspot_id: 'hotspot_' + uuidv4(),
        icon_url: '',
        is_dynamic: 0,
        ath: '',
        atv: '',
        title: '',
        is_show_title: 1,
        content: '',
        YTcontent: '',
        targetType: 1,
        titleFontSize: 14,
        tit_position_align: 'top',
        tit_position_edge: 'bottom',
        tit_position_x: 0,
        tit_position_y: 0,
        icon_scale: 50,
      },
      currFontSize: 16,
      currScale: 50,
      curr_align: 'top',
      curr_edge: 'bottom',
      curr_x: 0,
      curr_y: 0,
      currTitle: '',
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          // console.log("=0=", value);
          this.linkObj = value;
          this.currFontSize = this.linkObj.titleFontSize;
          this.currScale = this.linkObj.icon_scale;
          this.curr_x = this.linkObj.tit_position_x;
          this.curr_y = this.linkObj.tit_position_y;
          this.currTitle = this.linkObj.title;
          if (this.linkObj.tit_position_align == 'top') {
            this.currentPosition = 0;
          } else if (this.linkObj.tit_position_align == 'bottom') {
            this.currentPosition = 1;
          } else if (this.linkObj.tit_position_align == 'left') {
            this.currentPosition = 2;
          } else if (this.linkObj.tit_position_align == 'right') {
            this.currentPosition = 3;
          } else {
            // If tit_position_align is not defined, default to 'top'
            this.currentPosition = 0;
            this.linkObj.tit_position_align = 'top';
          }

          // 判斷是否有YouTube的Url 將原網址改成空字串
          if (this.linkObj.YTcontent) {
            this.linkObj.content = '';
          }
        }
      },
      immediate: true,
      deep: true,
    },
    content: {
      handler: function () {
        this.$message.error('YouTube');
      },
    },
    newLinkObj: {
      handler: function (val, oldVal) {
        if (val.ath == '' && val.atv == '') {
          const vh = getSceneViewAt();
          this.linkObj.ath = vh.hlookat;
          this.linkObj.atv = vh.vlookat;
        }
        this.$emit('change', this.linkObj, oldVal);
      },
      deep: true,
    },
    currTitle: {
      handler: function (value) {
        const id = this.linkObj.hotspot_id;
        setTitle(id, value);
      },
      deep: true,
    },
    currScale: {
      handler: function (value) {
        const id = this.linkObj.hotspot_id;
        setIconScale(id, value);
      },
      deep: true,
    },
    currFontSize: {
      handler: function (value) {
        const id = this.linkObj.hotspot_id;
        const css = 'css';
        var value =
          'text-align:center; color:#FFFFFF; font-family:MicrosoftYahei; font-size:' +
          value +
          'px';
        setTitlePosition(id, value, css);
      },
      deep: true,
    },
    curr_x: {
      handler: function (value) {
        const id = this.linkObj.hotspot_id;
        // const x = 'x';
        // setTitlePosition(id, value, x);

        const axis = 'x';
        // 若左右對立，送反號
        const send = this.isOppositeX(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
    curr_y: {
      handler: function (value) {
        const id = this.linkObj.hotspot_id;
        // const y = 'y'
        // setTitlePosition(id, value, y);

        const axis = 'y';
        // 若上下對立，送反號
        const send = this.isOppositeY(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['vrbase', 'currentScenesId', 'userInfo']),
    newLinkObj() {
      return this.$deepClone(this.linkObj);
    },
  },
  mounted() {
    this.$bus.$on('updateHotspot', (e) => {
      if (e.hotspot_id == this.linkObj.hotspot_id) {
        this.linkObj.ath = e.ath;
        this.linkObj.atv = e.atv;
      }
    });
  },
  methods: {
    handleInputFocus() {
      if (this.linkObj.YTcontent) {
        Modal.warning({
          title: '提示',
          content: this.$t('edit.hpInfo.linkSitesWarrning'),
        });
      }
    },
    isOppositeY(align, edge) {
      return align === 'bottom' && edge === 'top';
    },
    isOppositeX(align, edge) {
      return align === 'right' && edge === 'left';
    },
    onClickBtn(item, index) {
      this.currentPosition = index;
      const currId = this.linkObj.hotspot_id;
      console.log('觸發onClickBtn', '\nitem:', item);

      // 重新把目前的 x/y（滑桿數值）送進 krpano，但在送之前做對立翻號
      const sendX = this.isOppositeX(this.curr_align, this.curr_edge)
        ? -this.curr_x
        : this.curr_x;
      const sendY = this.isOppositeY(this.curr_align, this.curr_edge)
        ? -this.curr_y
        : this.curr_y;

      // 再把調整後的位移送進 krpano
      setTitlePosition(currId, sendX, 'x');
      setTitlePosition(currId, sendY, 'y');

      setHotspotTitlePosition(item, currId);
      this.curr_align = item.align;
      this.curr_edge = item.edge;
      this.curr_x = item.x;
      this.curr_y = item.y;
    },
    targetChange(e) {
      this.linkObj.targetType = e.target.value;
    },
    onSelectIcon(item) {
      this.linkObj.icon_url = item.icon_url;
      this.linkObj.is_dynamic = item.is_dynamic;
    },
    isShowTitle(e) {
      this.linkObj.is_show_title = e.target.checked ? 1 : 0;
    },
    clickBack() {
      this.$emit('clickBack', this.linkObj);
    },
    clickDelete() {
      this.$emit('clickDelete', this.linkObj);
    },
    onClickSave() {
      this.linkObj.title = this.currTitle;
      if (this.linkObj.targetType == 3) {
        // 將YouTube的Url改成Youtube的iframe使用的代碼
        var YTurl = this.linkObj.YTcontent
          ? this.linkObj.YTcontent
          : this.linkObj.content;
        const isYouTubeUrl =
          /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)/.test(
            YTurl
          );
        if (isYouTubeUrl) {
          let id;
          if (YTurl.includes('youtu.be/')) {
            const parts = YTurl.split('/');
            id = parts[parts.length - 1];
            console.log('idTrue', id);
          } else {
            const regex = /(?:v=|\/embed\/|youtu\.be\/)([\w-]+)/;
            const match = YTurl.match(regex);
            id = match && match[1];
            console.log('idFalse', id);
          }
          if (id !== null) {
            this.linkObj.content = `https://www.youtube.com/embed/${id}`;
          }
        }
      }
      if (!this.linkObj.icon_url) {
        this.$message.error(this.$t('edit.hpInfo.hpIcon'));
        return;
      }
      if (!this.currTitle) {
        this.$message.error(this.$t('edit.hpInfo.inputTitle'));
        return;
      }
      if (!this.linkObj.content) {
        this.$message.error(this.$t('edit.hpInfo.linkSites'));
        return;
      }
      // this.linkObj.title = this.titleStr;
      // this.linkObj.content = this.linkStr;

      this.linkObj.titleFontSize = this.currFontSize;
      this.linkObj.icon_scale = this.currScale;
      this.linkObj.tit_position_align = this.curr_align;
      this.linkObj.tit_position_edge = this.curr_edge;
      this.linkObj.tit_position_x = this.curr_x;
      this.linkObj.tit_position_y = this.curr_y;
      this.$emit('saveDataToStore', {
        key: this.linkObj.hotspot_id,
        data: this.linkObj,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.target-type {
  margin-top: 12px;
  /deep/ .ant-radio-wrapper {
    margin-bottom: 6px;
  }
}
.title-input {
  text-align: center;
  width: 50%;
}
.tit-desc-px {
  display: inline-flex;
  align-items: center;
  padding: 5px;
}
.tit-px {
  text-align: right;
}
.title-type {
  width: 80%;
}
.tit_position_bg {
  height: 49px;
  background-color: #212121;
  width: 100%;
  display: flex;
  .positionBtn.tit_active {
    background-color: #7101ad;
    border-color: #7101ad;
  }
  .positionBtn:hover {
    background-color: #d485ff;
    border-color: #d485ff;
  }
}
.tit_position_btn {
  color: #fff;
  background-color: #404040;
  border-color: #2e2e2e;
  margin: 10px 4px;
  border: 1px solid;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #555;
}
.tit_position_btn:hover {
  background-color: #02a2aa;
  border-color: #02a2aa;
  border: 1px solid #fff;
}
.tit_active {
  background-color: #015c61;
  border-color: #015c61;
}
.tit_sliderbar_bg {
  height: auto;
  background-color: #212121;
  width: 100%;
}
.titleScaleBg {
  background-color: #212121;
}
</style>
